import $ from 'jquery';

import ShowMoreNews from './showMoreNews';

import 'theme/moydom/less/pages/post.less';
import 'theme/moydom/less/blocks/news.less';

$(() => {
    const showMoreCityNews = new ShowMoreNews({
        loader: 'news-show-more-loading',
        button: '.js-city-news-show-more',
        container: '.js-city-news-wrap',
        url: '/news/ajax-more',
    });

    showMoreCityNews.init();
});
